module.exports = __webpack_public_path__ + "static/media/login-proveedor.2d454962.png";